export const FETCH_PORTAL_REFERENCE = 'FETCH_PORTAL_REFERENCE';
export const SHOW_LOGIN_POPUP = 'SHOW_LOGIN_POPUP';
export const RESET_IDLE_TIMEOUT = 'RESET_IDLE_TIMEOUT';
export const SHOW_SESSION_EXPIRY_MESSAGE = 'SHOW_SESSION_EXPIRY_MESSAGE';
export const SHOW_DIFF_USER_POPUP = 'SHOW_DIFF_USER_POPUP';
export const SHOW_ACTIVE_TAB_POPUP = 'SHOW_ACTIVE_TAB_POPUP';
